import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from '../context/TranslationContext';
import Spinner from '../ui/Spinner';

export default function OAuth2Redirect() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    const redirect = sessionStorage.getItem('post_auth_redirect') || '/dashboard';
    sessionStorage.removeItem('post_auth_redirect');
    const timeoutId = setTimeout(() => {
      navigate(redirect, { replace: true });
    }, 1000);

    return () => clearTimeout(timeoutId);
  }, [navigate]);

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        background: 'var(--bg)',
      }}
    >
      <Spinner size="lg" label={t('loading')} />
    </div>
  );
}
